import React from 'react';

interface Props {
    [propName: string]: any;
}

class ErrorBoundary extends React.Component<Props, {
    hasError: boolean;
}> {
    constructor(props: Props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error: Error) {
        // 更新 state 使下一次渲染能够显示降级后的 UI
        console.error(error);
        return {hasError: true};
    }

    // componentDidCatch(error, errorInfo) {
    //     logErrorToMyService(error, errorInfo);
    // }

    render() {
        if (this.state.hasError) {
            // 你可以自定义降级后的 UI 并渲染
            return <h1>页面发生了错误...</h1>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
